import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;

//const Card = tw(motion.a)`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;
const Card = tw(motion.a)`rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;

//added w-9/12 to resize the logo 
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-16 xl:h-16 bg-center bg-cover relative rounded-t w-9/12 `}
`;

const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`text-lg font-semibold group-hover:text-primary-500`;
const CardContent = tw.p`mt-1 text-sm font-medium text-gray-600 `;
const CardPrice = tw.p`mt-4 text-xl font-bold`;


const TechGrid = ({
  heading = "Technologieën die we integreren in onze services",
  tabs = {
    Starters: [
      {
        imageSrc:
          "https://www.eureachi.com/wp-content/uploads/2020/11/logo-Teamleader.png?_t=1605708521",
        //title: "Veg Mixer",
      },
      {
        imageSrc:
          "https://www.amocrm.com/static/images/pages/integrations/logo/mailchimp.png",
        //title: "Macaroni",
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQvc-jeY9XCLIGOHVqPsX6CBDgA58irPhV1feu_j_28u1QqDCyuYTfCFTxGdpUlShPl0_k&usqp=CAU",
        //title: "Nelli",
      },
      {
        imageSrc:
          "https://nakedsecurity.sophos.com/wp-content/uploads/sites/2/2016/10/facebook.png?w=780&h=408&crop=1",
        //title: "Facebook",
      },
      {
        imageSrc:
          "https://d15tnd3q55f8nl.cloudfront.net/static/SG_Twilio_Lockup_Social-56f3cfd2f6b0c62422980170d57fac64.png",
        //title: "Cajun Chicken",
      },
      {
        imageSrc:
          "https://prowly-uploads.s3.eu-west-1.amazonaws.com/uploads/13536/assets/196166/original-7a9c03cf2631ed69ba3d06fb3ad3929b.png",
        //title: "Chillie Cake",
      },
      {
        imageSrc:
          "data:image/png;base64,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",
        //title: "Guacamole Mex",
      },
      {
        imageSrc:
          "https://www.klarna.com/assets/sites/7/2019/10/16114234/Mollie_logo_partnerdirectory.jpg",
        //title: "Mollie",
      }, 

      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFWEVf5SoiC1i4gkF1pbvUfNaTm1E4uIea2GBELiEa2ZFo8Rip2LGjfUYppOF1dqI9kgE&usqp=CAU",
        //title: "Bol",
      },
    //   {
    //     imageSrc:
    //       "https://waspsoftware.be/swfiles/logo/logo.png?nocache=20210316002454",
    //     //title: "Wasp",
    //   },
      {
        imageSrc:
          "https://www.shoxl.com/data/uploads/images/exact-logo.png",
        //title: "Exact",
      },
      {
        imageSrc:
          "https://www.channelengine.com/media/kkfdnp4v/miinto.jpg",
        //title: "Miinto",
      },
      {
        imageSrc:
          "https://www.mailerlite.com/site/themes/new/img/mailerlite.png",
        //title: "Cajun Chicken",
      },
    //   {
    //     imageSrc:
    //       "https://www.promotech.com/wp-content/uploads/2020/12/20201105081120-52a4e80a0d5305acd194d15c470bcdac09071d26c904e09ddd0426d720cdb5a1-jpg.jpg",
    //     //title: "Lightspeed",
    //   },
    //   {
    //     imageSrc:
    //       "https://peak.capital/wp-content/uploads/2016/12/channable-logo.png",
    //     //title: "Guacamole Mex",
    //   },
    //   {
    //     imageSrc:
    //       "https://www.euretco.com/media/1854/stockbase-logo-clean-cmyk.jpg?anchor=center&mode=crop&width=870&height=580&rnd=132113053900000000",
    //     //title: "Carnet Nachos",
    //   }
    ],

  }
}) => {
  /*
   * To customize the tabs, pass in data using the `tabs` prop. It should be an object which contains the name of the tab
   * as the key and value of the key will be its content (as an array of objects).
   * To see what attributes are configurable of each object inside this array see the example above for "Starters".
   */
  const tabsKeys = Object.keys(tabs);

  const [activeTab] = useState(tabsKeys[0]);

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderRow>
          <Header>{heading}</Header>
     
        </HeaderRow>

        {tabsKeys.map((tabKey, index) => (
          <TabContent
            key={index}
            variants={{
              current: {
                opacity: 1,
                scale:1,
                display: "flex",
              },
              hidden: {
                opacity: 0,
                scale:0.8,
                display: "none",
              }
            }}
            transition={{ duration: 0.4 }}
            initial={activeTab === tabKey ? "current" : "hidden"}
            animate={activeTab === tabKey ? "current" : "hidden"}
          >
            {tabs[tabKey].map((card, index) => (
              <CardContainer key={index}>
                <Card className="group" href={card.url} initial="rest" whileHover="hover" animate="rest">
                  <CardImageContainer imageSrc={card.imageSrc} alt="logo">
              
                  </CardImageContainer>
                  <CardText>
                    <CardTitle>{card.title}</CardTitle>
                    <CardContent>{card.content}</CardContent>
                    <CardPrice>{card.price}</CardPrice>
                  </CardText>
                </Card>
              </CardContainer>
            ))}
          </TabContent>
        ))}
      </ContentWithPaddingXl>
     
    </Container>
  );
};

export default TechGrid;